export const baseUrl = "https://botbackend.technoloaderitservices.com";

// export const baseUrl = "http://13.234.237.180:5001";
